import React from 'react';
import { Button, Card, ConfigProvider } from 'antd';

function DefaultSetupPage({ setActiveTab }) {
  return (
    <>
      <h4>Setup</h4>
      <ConfigProvider
        theme={{
          components: {
            Card: {
              headerBg: '#EBEAF2'
            }
          }
        }}
      >
        <div className='cardsOuter'>
          <Card
            title={
              <div className='cardsHeader'>
                <div style={{ color: '#19a73f' }}>Bill Pay Setup</div>
                <Button
                  className='printButton'
                  onClick={() => { setActiveTab(2) }}
                >
                  Manage Accounts
                </Button>
              </div>
            }
            size="small"
            style={{
              width: '100%',
            }}
          >
            <div className='cardsBody'>
              <div>
                <p style={{ margin: '0', fontWeight: 'bold' }}>Bank Accounts</p>
                <div style={{ display: 'flex', gap: 20 }}>
                  <div style={{ padding: 10 }}>
                    <label className='grayLabel'>Primary Account</label>
                    <p style={{ margin: '0', color: '#19a73f', }}>Bank of America</p>
                  </div>
                </div>
              </div>
              <div style={{ marginTop: 10 }}>
                <p style={{ margin: '0', fontWeight: 'bold' }}>Credit Cards</p>
                <div style={{ display: 'flex', gap: 20, marginTop: 10, paddingLeft: 10 }}>
                  {/* <div style={{ borderRight: '1px solid #EBEAF2', paddingRight: 20 }}>
                        <label className='grayLabel'>Accounts</label>
                        <p style={{ margin: '0', }}>5</p>
                      </div>
                      <div>
                        <label className='grayLabel'>Primary Account</label>
                        <p style={{ margin: '0', color: '#19a73f', }}>Bank of America</p>
                      </div> */}
                  <Button
                    className='printButton'
                  >
                    Add Credit Card
                  </Button>
                </div>
              </div>
            </div>
          </Card>
          <Card
            title={
              <div className='cardsHeader'>
                <div style={{ color: '#19a73f' }}>Vendors</div>
                <Button
                  className='printButton'
                >
                  Manage Vendors
                </Button>
              </div>
            }
            size="small"
            style={{
              width: '100%',
            }}
          >
            <div className='cardsBody'>
              <div>
                <div style={{ display: 'flex', gap: 20 }}>
                  <div style={{ borderRight: '1px solid #EBEAF2', paddingRight: 20 }}>
                    <label className='grayLabel'>Vendors</label>
                    <p style={{ margin: '0', }}>50</p>
                  </div>
                  <div style={{ borderRight: '1px solid #EBEAF2', paddingRight: 20 }}>
                    <label className='grayLabel'>Bill Pay Enabled</label>
                    <p style={{ margin: '0', color: '#19a73f', }}>40</p>
                  </div>
                  <div>
                    <label className='grayLabel'>Bill Pay Disabled</label>
                    <p style={{ margin: '0', color: '#F86764', }}>10</p>
                  </div>
                </div>
              </div>
            </div>
          </Card>
          <Card
            title={
              <div className='cardsHeader'>
                <div style={{ color: '#19a73f' }}>Statement Reconciliation Settings</div>
                <Button
                  className='printButton'
                >
                  Manage Statement Reconciliation Settings
                </Button>
              </div>
            }
            size="small"
            style={{
              width: '100%',
            }}
          >
            <div className='cardsBody'>
              <div>
                <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                  <label className='grayLabel'>
                    Click on
                    <strong> Manage Statement Reconciliation Settings </strong>
                    to Manage Contacts and Reconcile New Vendor
                  </label>
                </div>
              </div>
            </div>
          </Card>
          <Card
            title={
              <div className='cardsHeader'>
                <div style={{ color: '#19a73f' }}>Payment Approval</div>
              </div>
            }
            size="small"
            style={{
              width: '100%',
            }}

          >
            <div className='cardsBody'>
              <div>
                <div style={{ display: 'flex', gap: 20, alignItems: 'center' }}>
                  <label className='grayLabel'>
                    Lorem ipsum dolor sit amet consectetur adipisicing elit. Animi reprehenderit deserunt porro repellendus quisquam expedita, cupiditate illum nihil, repudiandae culpa doloribus dolores! Maiores nulla itaque illo. Quae dolorum rerum esse!
                  </label>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </ConfigProvider>
    </>
  )
}

export default DefaultSetupPage;
